/**
 * The one vendor a variant is sourced from: its preferred vendor when that's still one of its
 * VendorOnSku candidates (the column has no FK constraint, so it can point at a removed vendor),
 * otherwise the first candidate.
 *
 * Its own module on purpose — `useVariantTableData` calls it, and `IVariantSummary` is inferred
 * from that module, so importing anything that refers back to `IVariantSummary` would make the
 * inferred type circular and collapse it to `any`.
 */
export function pickSourcingVendor<T extends { id: string }>(
  vendors: T[],
  preferredVendorId: string | null | undefined,
): T | undefined {
  return vendors.find((v) => v.id === preferredVendorId) ?? vendors[0]
}
